import React, { useEffect } from 'react';
import {
  Authenticator,
  ThemeProvider,
  useTheme,
  View,
  Heading,
  Image,
  Button,
  Text,
} from '@aws-amplify/ui-react';
import { Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { signInWithRedirect } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import './style/CustomLogin.css';
import logoicon from '../assets/img/logobow.png';
import { useTranslation } from 'react-i18next'; 
import { I18n } from 'aws-amplify/utils';
import { translations, CheckboxField } from '@aws-amplify/ui-react';




const components = {
  Header() {
    const { tokens } = useTheme();
    
    return (
      <View
        textAlign="center"
        padding={tokens.space.large}
        className="login-logo-container"
      >
        <Image
          alt="Amplify logo"
          src={logoicon}
          height="80px"
        />
      </View>
    );

  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();
      const { t } = useTranslation(); 
      return (
        <Heading
          level={3}
          textAlign="center"
          padding={`${tokens.space.xl} 0 ${tokens.space.large}`}
        >
          {t("login.title")}
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();
      const { t } = useTranslation(); 
      const handleGoogleLogin = () => {
        //signInWithRedirect({ provider: 'Google' });
      };

      return (
        <View textAlign="center" marginTop="medium">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            {t("login.forgotPassword")}
          </Button>
          <View marginTop="medium">
            <Button onClick={handleGoogleLogin} variation="primary">
              {t("login.googleLogin")}
            </Button>
          </View>
        </View>
      );
    },
  },
  Footer() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>&copy; All Rights Reserved</Text>
      </View>
    );
  },
  SignUp: {
  FormFields() {
    const { validationErrors } = useAuthenticator();
    const { t } = useTranslation();

    return (
      <>
        <Authenticator.SignUp.FormFields />

        <CheckboxField
          errorMessage={validationErrors.acknowledgement}
          hasError={!!validationErrors.acknowledgement}
          name="acknowledgement"
          value="yes"
           label={
            <span style={{ color: 'white' }}>
              {t('login.termsLabel')}
            </span>
          }
        />
      </>
    );
  },
},

};

const customTheme = {
  name: 'BeOnWall Auth Theme',
  tokens: {
    components: {
      authenticator: {
        router: {
          borderRadius: '16px',
          padding: '32px',
          backgroundColor: 'rgba(255,255,255,0.05)',
          boxShadow: '0 12px 32px rgba(0,0,0,0.35)',
          backdropFilter: 'blur(12px)',
        },
      },
      button: {
        primary: {
          backgroundColor: '#3b82f6',
          borderRadius: '999px',
          color: 'white',
          _hover: {
            backgroundColor: '#2563eb',
          },
        },
      },
      heading: {
        color: 'white',
      },
      field: {
        label: {
          color: 'white',
        },
      },
      fieldcontrol: {
        color: 'white',
        _focus: {
          boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.4)',
        },
      },
      passwordfield: {
        button: {
          color: 'white',
        },
      },
    },
  },
};



export default function CustomLogin() {
  useEffect(() => {
    Hub.listen('auth', ({ payload }) => {
      console.log('[Cognito Auth Event]', payload.event, payload);
    });
  }, []);
  const { t } = useTranslation(); 
  const formFields = {
  signIn: {
    username: {
      label: t("login.Username"),
      placeholder: t("login.usernamePlaceholder"),
    },
    password: {
      label: t("login.Password"),
      placeholder: t("login.passwordPlaceholder"),
    },
  },
  signUp: {
    username: {
      label: t("login.Username"),
      placeholder: t("login.usernamePlaceholder"),
    },
    password: {
      label: t("login.Password"),
      placeholder: t("login.passwordPlaceholder"),
    },
    confirm_password: {
      label: t("login.ConfirmPassword"),
      placeholder: t("login.ConfirmPassword"),
    },
  },
  confirmSignUp: {
    confirmation_code: {
      label: t("login.ConfirmationCode"),
      placeholder: t("login.confirmationCodePlaceholder"),
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: t("login.ConfirmationCode"),
      placeholder: t("login.confirmationCodePlaceholder"),
    },
  },
  forgotPassword: {
    username: {
      label: t("login.Username"),
      placeholder: t("login.usernamePlaceholder"),
    },
    confirmation_code: {
      label: t("login.ConfirmationCode"),
      placeholder: t("login.confirmationCodePlaceholder"),
    },
    password: {
      label: t("login.Password"),
      placeholder: t("login.passwordPlaceholder"),
    },
  },
   setupEmail: {
    email: {
      label: t("login.email"),
      placeholder: t("login.emailPlaceholder"),
    },
  },
};
const { i18n } = useTranslation();

useEffect(() => {
  I18n.putVocabularies(translations);

  I18n.putVocabularies({
    fr: {
      'Sign In': 'Se connecter',
      'Sign in': 'Connexion',
      'Sign in to your account': 'Connectez-vous à votre compte',
      'Sign Up': "S'inscrire",
      Username: 'Nom d’utilisateur',
      Password: 'Mot de passe',
      'Forgot your password?': 'Mot de passe oublié ?',
      'Incorrect username or password.': 'Nom d’utilisateur ou mot de passe incorrect.',
      'User does not exist.': "Ce compte n'existe pas.",
      'Create account': 'Créer un compte',
      'Reset your password': 'Réinitialisez votre mot de passe',
      'Send code': 'Envoyer le code',
      'Back to Sign In': 'Retour à la connexion',
      'Confirm Password': 'Confirmer le mot de passe',
    },
    en: {
      'Sign In': 'Sign in',
      'Sign in': 'Login',
      'Sign in to your account': 'Sign in to your account',
      'Sign Up': 'Sign up',
      Username: 'Username',
      Password: 'Password',
      'Forgot your password?': 'Forgot your password?',
      'Incorrect username or password.': 'Incorrect username or password.',
      'User does not exist.': 'This account does not exist.',
      'Create account': 'Create account',
      'Reset your password': 'Reset your password',
      'Send code': 'Send code',
      'Back to Sign In': 'Back to Sign In',
      'Confirm Password': 'Confirm Password',
    },
  });

  // ✅ Ici on synchronise avec react-i18next
  I18n.setLanguage(i18n.language);
}, [i18n.language]);


  return (
    <div className="login-page">
      <div className="login-page-container">
        <ThemeProvider theme={customTheme}>
          <Authenticator  formFields={formFields} components={components} hideSignUp={false}
            services={{
              async validateCustomSignUp(formData) {
                if (!formData.acknowledgement) {
                  return {
                    acknowledgement: i18n.language === 'fr'
                      ? 'Vous devez accepter les conditions générales.'
                      : 'You must agree to the Terms and Conditions.',
                  };
                }
              },
            }}
          
          >
            {({ user }) => (user ? <Navigate to="/homelogin" /> : null)}
          </Authenticator>
        </ThemeProvider>
      </div>
    </div>
  );
}
